<template>
  <app-swiper
    :free-mode="false"
    :show-pagination="false"
    :space-between="0"
    :slide-per-view="1"
    :currentSlidePosition="currentSlidePosition"
    custom-class="!h-full "
    :swiperClass="''"
    v-model="slidePosition"
    :auto-play="
      Logic.Common.currentBuildType() == 'web'
        ? {
            delay: 7000,
          }
        : false
    "
    id="swiperContainer"
  >
    <!-- Slide 1 -->
    <swiper-slide
      class="!h-screen !flex !flex-col items-start relative justify-center bg-white"
    >
      <div
        class="w-full flex flex-col items-center justify-start h-full relative space-y-2"
        style="padding-top: calc(env(safe-area-inset-top) + 16px)"
      >
        <!-- Top sections -->
        <div
          class="w-full flex flex-col items-center justify-center px-5 mdlg:!pt-2 md:!pt-2 space-y-3"
        >
          <img src="/images/splash/logo.svg" alt="logo" class="h-[26px]" />
          <app-normal-text
            class="!text-black text-center !font-regular !text-[20px] xs:!text-sm font-figtree"
          >
            SHOP, PAY, AND SAVE <br />
            CASHBACK EVERYDAY YOU<br />
            <b class="!font-bold">SPEND WITH ONE APP</b>
          </app-normal-text>
        </div>

        <div
          class="w-full flex flex-col items-center justify-center h-full flex-grow"
          style="
            background: url('/images/splash/slide-1.png') no-repeat top center;
            background-size: cover;
          "
        ></div>

        <!-- Bottom section -->
        <div
          class="w-full flex flex-row items-center justify-between space-x-3 px-4 absolute bottom-0 left-0 right-0 z-50"
          style="padding-bottom: calc(env(safe-area-inset-bottom) + 16px)"
        >
          <app-button
            :padding="'px-9 py-3 xs:!px-6 xs:!py-2'"
            :customClass="`!bg-[#EBDDF4] !text-[#470087]  !font-semibold  !uppercase !xs:text-[10px] font-figtree  ${
              Logic.Common.currentBuildType() == 'web' ? 'invisible' : ''
            }`"
            :border="''"
            @click="currentSlidePosition = 6"
          >
            Skip
          </app-button>

          <app-button
            :padding="'px-9 py-3 xs:!px-6 xs:!py-2'"
            :custom-class="'!bg-[#9411EF] !text-white  !font-semibold  !uppercase !xs:text-[10px] font-figtree'"
            @click="currentSlidePosition++"
            :border="''"
          >
            Next
          </app-button>
        </div>
      </div>
    </swiper-slide>

    <!-- Slide 2 -->
    <swiper-slide
      class="!h-screen !flex !flex-col items-start relative justify-start bg-[#470087]"
    >
      <div
        class="w-full flex flex-col items-center justify-start h-full relative"
        style="padding-top: calc(env(safe-area-inset-top) + 16px)"
      >
        <!-- Top sections -->
        <div
          class="w-full flex flex-col items-center px-4 z-30 max-h-[90%] mdlg:!pt-6 md:!pt-6"
        >
          <app-normal-text
            class="!text-white text-center !font-regular !text-[20px] xs:!text-sm font-figtree"
          >
            SNAP RECEIPTS AND GET <br />
            <b class="!font-bold">CASHBACK SAVINGS </b>
            <br />
            <b class="!font-bold">FOR PURCHASES ANYWHERE</b>
          </app-normal-text>
        </div>

        <div
          class="w-full flex flex-col items-center justify-center h-full flex-grow"
          style="
            background: url('/images/splash/slide-2.png') no-repeat top center;
            background-size: cover;
          "
        ></div>

        <!-- Bottom section -->
        <div
          class="w-full flex flex-row items-center justify-between space-x-3 px-4 absolute bottom-0 left-0 right-0 z-50"
          style="padding-bottom: calc(env(safe-area-inset-bottom) + 16px)"
        >
          <app-button
            :padding="'px-9 py-3 xs:!px-6 xs:!py-2'"
            :customClass="`!bg-[#EBDDF4] !text-[#470087]  !font-semibold  !uppercase !xs:text-[10px] font-figtree  ${
              Logic.Common.currentBuildType() == 'web' ? 'invisible' : ''
            }`"
            :border="''"
            @click="currentSlidePosition = 6"
          >
            Skip
          </app-button>

          <app-button
            :padding="'px-9 py-3 xs:!px-6 xs:!py-2'"
            :custom-class="'!bg-[#9411EF] !text-white  !font-semibold  !uppercase !xs:text-[10px] font-figtree'"
            @click="currentSlidePosition++"
            :border="''"
          >
            Next
          </app-button>
        </div>
      </div>
    </swiper-slide>

    <!-- Slide 3 -->
    <swiper-slide
      class="!h-screen !flex !flex-col items-start relative justify-start bg-[#ffffff]"
    >
      <div
        class="w-full flex flex-col items-center justify-start h-full relative"
        style="padding-top: calc(env(safe-area-inset-top) + 16px)"
      >
        <!-- Top sections -->
        <div
          class="w-full flex flex-col items-center justify-center px-5 mdlg:!pt-2 md:!pt-2 space-y-3 pb-3"
        >
          <app-normal-text
            class="!text-black text-center !font-regular !text-[20px] xs:!text-sm font-figtree"
          >
            TRACK EXPENSES AND <br />
            <b class="!font-bold">SAVE MORE EFFORTLESSLY</b>
          </app-normal-text>
        </div>

        <div
          class="w-full flex flex-col items-center justify-center h-full flex-grow"
          style="
            background: url('/images/splash/slide-3.png') no-repeat top center;
            background-size: cover;
          "
        ></div>

        <!-- Bottom section -->
        <div
          class="w-full flex flex-row items-center justify-between space-x-3 px-4 absolute bottom-0 left-0 right-0 z-50"
          style="padding-bottom: calc(env(safe-area-inset-bottom) + 16px)"
        >
          <app-button
            :padding="'px-9 py-3 xs:!px-6 xs:!py-2'"
            :customClass="`!bg-[#EBDDF4] !text-[#470087]  !font-semibold  !uppercase !xs:text-[10px] font-figtree  ${
              Logic.Common.currentBuildType() == 'web' ? 'invisible' : ''
            }`"
            :border="''"
            @click="currentSlidePosition = 6"
          >
            Skip
          </app-button>

          <app-button
            :padding="'px-9 py-3 xs:!px-6 xs:!py-2'"
            :custom-class="'!bg-[#9411EF] !text-white  !font-semibold  !uppercase !xs:text-[10px] font-figtree'"
            @click="currentSlidePosition++"
            :border="''"
          >
            Next
          </app-button>
        </div>
      </div>
    </swiper-slide>

    <!-- Slide 4 -->
    <swiper-slide
      class="!h-screen !flex !flex-col items-start relative justify-start bg-[#470087]"
    >
      <div
        class="w-full flex flex-col items-center justify-start h-full relative"
        style="padding-top: calc(env(safe-area-inset-top) + 16px)"
      >
        <!-- Top sections -->
        <div
          class="w-full flex flex-col items-center px-4 z-30 max-h-[90%] mdlg:!pt-6 md:!pt-6"
        >
          <app-normal-text
            class="!text-white text-center !font-regular !text-[20px] xs:!text-sm font-figtree"
          >
            DISCOVER EXCLUSIVE <b class="!font-bold">SAVINGS </b>
            <br />
            <b class="!font-bold"> AND DEALS FOR YOU DAILY</b>
          </app-normal-text>
        </div>

        <div
          class="w-full flex flex-col items-center justify-center h-full flex-grow"
          style="
            background: url('/images/splash/slide-4.png') no-repeat top center;
            background-size: cover;
          "
        ></div>

        <!-- Bottom section -->
        <div
          class="w-full flex flex-row items-center justify-between space-x-3 px-4 absolute bottom-0 left-0 right-0 z-50"
          style="padding-bottom: calc(env(safe-area-inset-bottom) + 16px)"
        >
          <app-button
            :padding="'px-9 py-3 xs:!px-6 xs:!py-2'"
            :customClass="`!bg-[#EBDDF4] !text-[#470087]  !font-semibold  !uppercase !xs:text-[10px] font-figtree  ${
              Logic.Common.currentBuildType() == 'web' ? 'invisible' : ''
            }`"
            :border="''"
            @click="currentSlidePosition = 6"
          >
            Skip
          </app-button>

          <app-button
            :padding="'px-9 py-3 xs:!px-6 xs:!py-2'"
            :custom-class="'!bg-[#9411EF] !text-white  !font-semibold  !uppercase !xs:text-[10px] font-figtree'"
            @click="currentSlidePosition++"
            :border="''"
          >
            Next
          </app-button>
        </div>
      </div>
    </swiper-slide>

    <!-- Slide 5 -->
    <swiper-slide
      class="!h-screen !flex !flex-col items-start relative justify-start bg-[#ffffff]"
    >
      <div
        class="w-full flex flex-col items-center justify-start h-full relative"
        style="padding-top: calc(env(safe-area-inset-top) + 16px)"
      >
        <!-- Top sections -->
        <div
          class="w-full flex flex-col items-center justify-center px-5 mdlg:!pt-2 md:!pt-2 space-y-3 pb-3"
        >
          <app-normal-text
            class="!text-black text-center !font-regular !text-[20px] xs:!text-sm font-figtree"
          >
            <b class="!font-bold">ONE APP FOR ALL YOUR</b> <br />
            EVERYDAY ESSENTIAL AND SHOPPING NEEDS
          </app-normal-text>
        </div>

        <div
          class="w-full flex flex-col items-center justify-center h-full flex-grow"
          style="
            background: url('/images/splash/slide-5.png') no-repeat top center;
            background-size: cover;
          "
        ></div>

        <!-- Bottom section -->
        <div
          class="w-full flex flex-row items-center justify-between space-x-3 px-4 absolute bottom-0 left-0 right-0 z-50"
          style="padding-bottom: calc(env(safe-area-inset-bottom) + 16px)"
        >
          <app-button
            :padding="'px-9 py-3 xs:!px-6 xs:!py-2'"
            :customClass="`!bg-[#EBDDF4] !text-[#470087]  !font-semibold  !uppercase !xs:text-[10px] font-figtree  ${
              Logic.Common.currentBuildType() == 'web' ? 'invisible' : ''
            }`"
            :border="''"
            @click="currentSlidePosition = 6"
          >
            Skip
          </app-button>

          <app-button
            :padding="'px-9 py-3 xs:!px-6 xs:!py-2'"
            :custom-class="'!bg-[#9411EF] !text-white  !font-semibold  !uppercase !xs:text-[10px] font-figtree'"
            @click="currentSlidePosition++"
            :border="''"
          >
            Next
          </app-button>
        </div>
      </div>
    </swiper-slide>

    <!-- Slide 6 -->

    <swiper-slide
      class="!h-screen !flex !flex-col items-start relative justify-start bg-[#470087]"
    >
      <div
        class="w-full flex flex-col items-center justify-start h-full relative"
        style="padding-top: calc(env(safe-area-inset-top) + 16px)"
      >
        <!-- Top sections -->
        <div
          class="w-full flex flex-col items-center px-4 z-30 max-h-[90%] mdlg:!pt-6 md:!pt-6"
        >
          <app-normal-text
            class="!text-white text-center !font-regular !text-[20px] xs:!text-sm font-figtree"
          >
            MORE CASHBACK FOR
            <br />
            <b class="!font-bold">
              EVERYDAY BILL PAYMENTS,<br />
              GIFT CARDS, AND MORE!</b
            >
          </app-normal-text>
        </div>

        <div
          class="w-full flex flex-col items-center justify-center h-full flex-grow"
          style="
            background: url('/images/splash/slide-6.png') no-repeat top center;
            background-size: cover;
          "
        ></div>

        <!-- Bottom section -->
        <div
          class="w-full flex flex-row items-center justify-between space-x-3 px-4 absolute bottom-0 left-0 right-0 z-50"
          style="padding-bottom: calc(env(safe-area-inset-bottom) + 16px)"
        >
          <app-button
            :padding="'px-9 py-3 xs:!px-6 xs:!py-2'"
            :customClass="`!bg-[#EBDDF4] !text-[#470087]  !font-semibold  !uppercase !xs:text-[10px] font-figtree  ${
              Logic.Common.currentBuildType() == 'web' ? 'invisible' : ''
            }`"
            :border="''"
            @click="currentSlidePosition = 6"
          >
            Skip
          </app-button>

          <app-button
            :padding="'px-9 py-3 xs:!px-6 xs:!py-2'"
            :custom-class="'!bg-[#9411EF] !text-white  !font-semibold  !uppercase !xs:text-[10px] font-figtree'"
            @click="currentSlidePosition++"
            :border="''"
          >
            Next
          </app-button>
        </div>
      </div>
    </swiper-slide>

    <!-- Slide 7 -->
    <swiper-slide
      class="!h-screen !flex !flex-col items-start relative justify-start bg-[#470087]"
    >
      <div
        class="w-full flex flex-col items-center justify-start h-full relative"
        style="padding-top: calc(env(safe-area-inset-top) + 16px)"
      >
        <!-- Top sections -->
        <div
          class="w-full flex flex-col items-center px-4 z-30 max-h-[90%] mdlg:!pt-6 md:!pt-6 pb-3"
        >
          <app-normal-text
            class="!text-white text-center !font-regular !text-[20px] xs:!text-sm font-figtree"
          >
            REDEEM MONTHLY
            <br />
            <b class="!font-bold">
              CASHBACK SAVINGS FOR <br />
              EVERYDAY PAYMENTS</b
            >
          </app-normal-text>
        </div>

        <div
          class="w-full flex flex-col items-center justify-center h-full flex-grow"
          style="
            background: url('/images/splash/slide-7.png') no-repeat top center;
            background-size: cover;
          "
        ></div>

        <!-- Bottom section -->
        <div
          v-if="Logic.Common.currentBuildType() == 'mobile'"
          class="w-full flex flex-col space-y-4 items-center justify-between space-x-3 px-4 pt-4 absolute bottom-0 left-0 right-0 h-auto z-30 bg-white rounded-t-[10px]"
          style="padding-bottom: calc(env(safe-area-inset-bottom) + 16px)"
        >
          <!-- Top section -->
          <div class="w-full flex flex-row items-center justify-between">
            <app-header-text
              class="!text-black font-bold text-center !text-sm xs:!text-xs"
            >
              Get Started
            </app-header-text>
            <app-button
              @click="Logic.Common.GoToRoute('/auth/login')"
              :custom-class="'rounded-[40px] font-500 text-[14px]'"
              :bg-color="'bg-primary-50'"
              :text-color="'text-primary-500'"
              :padding="'px-3 py-[2px]'"
            >
              Login
            </app-button>
          </div>

          <div class="w-full flex flex-col space-y-3 justify-center items-center">
            <div class="w-full flex flex-col">
              <app-button
                @click.prevent="Logic.Common.GoToRoute('/auth/signup')"
                :padding="'py-3'"
                :bg-color="'bg-primary-main'"
                :text-color="'text-white'"
                class="w-full"
              >
                Sign up with Email
              </app-button>
            </div>

            <!-- SSO -->
            <SSO :fromAction="'signUp'" :isRelative="true" />
          </div>
        </div>
      </div>
    </swiper-slide>
  </app-swiper>
</template>

<script lang="ts">
import { defineComponent, ref, watch } from "vue";
import { useRouter } from "vue-router";
import { Logic } from "../../index";
import {
  AppSwiper,
  AppButton,
  AppNormalText,
  AppHeaderText,
  AppIcon,
} from "../../components";
import { SwiperSlide } from "swiper/vue";
import SSO from "./SSO.vue";

export default defineComponent({
  components: {
    AppSwiper,
    AppButton,
    AppNormalText,
    AppHeaderText,
    AppIcon,
    SwiperSlide,
    SSO,
  },
  setup() {
    const router = useRouter();

    const slidePosition = ref(0);

    const currentSlidePosition = ref(0);

    watch(slidePosition, () => {
      currentSlidePosition.value = slidePosition.value;
    });

    localStorage.setItem("user_onboarded", "true");

    const goToRoute = (route: string) => {
      router.push(route);
    };

    return {
      slidePosition,
      currentSlidePosition,
      Logic,
      goToRoute,
    };
  },
});
</script>
